import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

import axios from './axios-config';
import onAjaxComplete from './ajax_complete';

class SessionTimer extends React.Component {
  constructor(props) {
    super(props);
    const { warnIn, timeoutIn } = this.props;
    this.state = {
      showWarning: false,
      warnAt: Date.now() + warnIn * 1000,
      timeoutAt: Date.now() + timeoutIn * 1000
    };

    this.doSignOut = this.doSignOut.bind(this);
    this.keepAlive = this.keepAlive.bind(this);
    this.resetTimeout = this.resetTimeout.bind(this);
    this.showWarningModal = this.showWarningModal.bind(this);
    this.checkTime = this.checkTime.bind(this);

    setTimeout(this.checkTime, 5 * 1000);
    onAjaxComplete(this.resetTimeout);
  }

  componentWillUnmount() {
    window.removeEventListener('loadend', this.resetTimeout, false);
  }

  doSignOut = async () => {
    const { signOutPath, signInPath } = this.props;
    const response = await axios.delete(signOutPath);
    if (response) {
      window.location.assign(signInPath);
    }
  };

  checkTime() {
    const { timeoutAt, warnAt } = this.state;
    if (Date.now() > timeoutAt) {
      this.doSignOut();
    } else if (Date.now() > warnAt) {
      this.showWarningModal();
    }

    setTimeout(this.checkTime, 5 * 1000);
  }

  keepAlive() {
    const { pingPath } = this.props;
    axios.get(pingPath);
    this.resetTimeout();
    this.setState({ showWarning: false });
  }

  resetTimeout() {
    const { warnIn, timeoutIn } = this.props;
    this.setState({
      warnAt: Date.now() + warnIn * 1000,
      timeoutAt: Date.now() + timeoutIn * 1000
    });
  }

  showWarningModal() {
    this.setState({
      showWarning: true
    });
  }

  goToLogin() {
    const { signInPath } = this.props;
    window.location = signInPath;
  }

  warningText() {
    const { timeoutIn } = this.props;
    return (
      <p>
        <strong>Your current session is about to expire.</strong> For your security, sessions are
        set to expire after {timeoutIn / 60} minutes of inactivity. This greatly reduces the chances
        of someone else accessing sensitive information if you forget to logout. To continue your
        session, please select &ldquo;Continue&rdquo; from the options below.
      </p>
    );
  }

  render() {
    const { signOutPath } = this.props;
    const { showWarning } = this.state;

    return (
      <Modal
        backdrop="static"
        dialogClassName="session-timeout-modal"
        keyboard={false}
        show={showWarning}
      >
        <Modal.Header>
          <h4 className="modal-title">Are you still there?</h4>
        </Modal.Header>
        <Modal.Body>{this.warningText()}</Modal.Body>
        <Modal.Footer>
          <a
            rel="nofollow"
            type="button"
            className="btn btn-default"
            data-method="delete"
            href={signOutPath}
          >
            LOGOUT
          </a>
          <button type="button" className="btn btn-primary" onClick={this.keepAlive}>
            CONTINUE
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SessionTimer.propTypes = {
  pingPath: PropTypes.string.isRequired,
  signInPath: PropTypes.string.isRequired,
  signOutPath: PropTypes.string.isRequired,
  timeoutIn: PropTypes.number.isRequired,
  warnIn: PropTypes.number.isRequired
};

export default SessionTimer;
